import React from "react";
import { useLocation, Link } from "react-router-dom";
import styled from "styled-components";

const StyledNavLink = styled.span`
  cursor: pointer;

  & a:hover,
  & a:active {
    color: ${(props) => props.theme.colors.second};
  }
`;

const StyledNavLinkActive = styled.span`
  color: ${(props) => props.theme.colors.navActive};

  & a:hover,
  & a:active {
    color: ${(props) => props.theme.colors.navActive};
  }
`;

const NavLink = ({ link, label }) => {
  const location = useLocation();
  if (!label) label = link.label;
  const isActive = location.pathname === link.route;

  if (!link.route) {
    console.error(`NavLink - link.route is not set`);
    console.log(link);
    console.log(label);
  }

  const activeLink = (
    <StyledNavLinkActive>
      <Link to={link.route}>{label}</Link>
    </StyledNavLinkActive>
  );
  const inActiveLink = (
    <StyledNavLink>
      <Link to={link.route}>{label}</Link>
    </StyledNavLink>
  );

  return isActive || !link.route ? activeLink : inActiveLink;
};

export default NavLink;
